import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  AssistantOpenContext,
  DiscoverViewContext,
} from "contexts/DiscoverView";
import { useContext } from "react";

import { isAssistantAvailable } from "./index";

interface Props {
  title: string;
  body: string;
  openContext?: AssistantOpenContext;
  fullWidthButton?: boolean;
}

const AssistantCTA = ({
  title,
  body,
  openContext,
  fullWidthButton = false,
}: Props) => {
  const { openAssistant } = useContext(DiscoverViewContext);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const stacked = fullWidthButton || isMobileScreen;
  if (!isAssistantAvailable()) return null;

  const iconCircle = (
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: PALETTE.iconBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <Box
        component="i"
        className="fa-solid fa-sparkles"
        sx={{ color: "white", fontSize: 14 }}
      />
    </Box>
  );

  const textBlock = (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: 13, color: "#4A5565", mt: 0.25 }}>
        {body}
      </Typography>
    </Box>
  );

  const button = (
    <Button
      fullWidth={stacked}
      disableElevation
      onClick={() => openAssistant(openContext)}
      sx={{
        textTransform: "none",
        backgroundColor: PALETTE.buttonBg,
        color: "white",
        fontWeight: 600,
        fontSize: 14,
        px: 2,
        py: 1,
        flexShrink: 0,
        "&:hover": { backgroundColor: PALETTE.buttonHover },
      }}
      startIcon={
        <Box
          component="i"
          className="fa-solid fa-sparkles"
          sx={{ fontSize: 13 }}
        />
      }
    >
      Start AI Chat
    </Button>
  );

  return (
    <Box
      sx={{
        borderRadius: 2,
        border: `1px solid ${PALETTE.border}`,
        backgroundColor: PALETTE.background,
        p: 2,
        mb: 2,
      }}
    >
      {stacked ? (
        <>
          <Stack direction="row" spacing={1.5} alignItems="flex-start">
            {iconCircle}
            {textBlock}
          </Stack>
          <Box sx={{ mt: 1.5, display: "flex" }}>{button}</Box>
        </>
      ) : (
        <Stack direction="row" spacing={2} alignItems="center">
          {iconCircle}
          {textBlock}
          {button}
        </Stack>
      )}
    </Box>
  );
};

const PALETTE = {
  background: "#fafaf6",
  border: "rgba(1, 70, 56, 0.12)",
  iconBg: "#014638",
  buttonBg: "#014638",
  buttonHover: "#151F16",
};

export default AssistantCTA;
